<template>
  <div>
    <v-app-bar
      app
      class="primary"
      :height="$vuetify.breakpoint.xsOnly ? 104 : 53"
      style="z-index: 999"
    >
      <v-container fluid class="pa-0" style="height: 100%;">
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          class="fill-height"
        >

          <v-col
            cols="12"
            sm="2"
            md="2"
            lg="2"
            class="d-flex align-center justify-center justify-sm-start mb-1 pl-sm-4"
          >
            <router-link
              v-if="navAItemsMain.linkTo"
              :to="{ name: navAItemsMain.linkTo }"
              style="text-decoration: none;"
            >
              <v-img
                alt="Psycp Logo"
                class="shrink"
                height="36"
                contain
                src="@/assets/Logo_sx.png"
                max-width="120"
              />
            </router-link>
          </v-col>

          <v-col
            cols="auto"
            sm="9"
            md="9"
            lg="9"
            class="d-flex align-center justify-start justify-sm-center"
          >
            <v-tabs
              :centered="$vuetify.breakpoint.smAndUp"
              background-color="transparent"
              class="flex-nowrap"
            >
              <v-tab
                v-for="(item, index) in navAItems"
                :key="index"
                :to="item.to"
                style="text-decoration: none; color: inherit; min-width: 0;"
                class="px-5 px-sm-6 px-md-5"
              >
                <a class="secundary--text d-flex align-center" style="text-transform: none">
                  <v-icon class="secundary--text mr-0 mr-md-1" size="24px">{{ item.icon }}</v-icon>
                  
                  <span v-show="$vuetify.breakpoint.mdAndUp">
                    {{ item.name }}
                  </span>
                </a>
              </v-tab>
            </v-tabs>
          </v-col>

          <v-col
            cols="auto"
            xs="1"
            sm="1"
            md="1"
            lg="1"
            class="ml-auto d-flex align-center justify-end"
          >
            <v-avatar-menu :avatarItems="avatarItems" :logOut="logOut" />
          </v-col>

        </v-row>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import apiClient from '@/api/apiClient.js';
import VAvatarMenu from '@/components/base/VAvatarMenu.vue';

export default {
  name: 'MainHeaderPlatA',
  components: {
    VAvatarMenu,
  },
  data() {
    return {
      navAItemsMain: {},
      avatarItems: {},
      navAItems: [],
    };
  },

  computed: {
    ...mapGetters('auth', ['authData']), 
  },

  mounted() {
    this.loadSchema();
  },

  methods: {
    async loadSchema() {
      try {
        const res = await apiClient.mainHeaderPlatASchema();
        const schemaMainHeader = res.data;
        this.navAItemsMain = schemaMainHeader.navAItemsMain;
        this.navAItems = schemaMainHeader.navAItems;
        let name = this.authData.users_first_name;
        const avatarItems = schemaMainHeader.navAItemsMain.avatarItems;
        avatarItems.fullName = this.authData.users_first_name;
        avatarItems.initials = name.charAt(0).toUpperCase();
        this.avatarItems = avatarItems;
      } catch {
        console.error('Error detectado');
      }
    },
    async logOut() {
      let logOut = 1;
      this.$store.dispatch('auth/logOut', logOut).then(
        () => {
          this.$router.push('/');
          delete axios.defaults.headers.common['Authorization'];
        },
        () => {}
      );
    },
    scroll(refName) {
      const element = document.getElementById(refName);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>